/* TLB Shop the Look (v1.9: hands video cards / players to window.TLBVideo, assets/tlb-video.js).
   - Tabs: links to server-rendered views (?view=looks-<tag>); enhanced to swap the grid in place (no page jump).
   - "More looks": appends the next server page (Section Rendering API) instead of navigating.
   - Look cards: open the look in a <dialog> (fragment from ?view=look-frag&page=<rank>) and push the look's own URL
     (?view=look&page=<rank>, a real, shareable, crawlable page). Back/Escape/backdrop close it.
   Product links inside are exact LTK links, untouched. */
(function () {
  var root = document.querySelector('[data-tlb-looks]');
  if (!root) return;
  var dlg = root.querySelector('[data-dialog]');
  var body = root.querySelector('[data-dialog-body]');
  var feedUrl = location.href, openRank = null;

  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    return (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight) ? pw : null;
  }
  function toGridTop() {
    var nav = root.querySelector('.tlb-looks__nav'), anchor = root.querySelector('.tlb-looks__bar');
    if (!nav || !anchor) return;
    var sc = scroller(), cur = sc ? sc.scrollTop : window.scrollY;
    var top = anchor.getBoundingClientRect().top + cur - (parseFloat(getComputedStyle(nav).top) || 0) - nav.offsetHeight;
    if (cur > top) { if (sc) sc.scrollTo({ top: top, behavior: 'smooth' }); else window.scrollTo({ top: top, behavior: 'smooth' }); }
  }
  function fetchDoc(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }
  function withParam(url, k, v) { var u = new URL(url, location.href); u.searchParams.set(k, v); return u.toString(); }

  /* Tabs */
  root.addEventListener('click', function (ev) {
    var tab = ev.target.closest && ev.target.closest('.tlb-looks__tab');
    if (!tab || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
    ev.preventDefault();
    var href = tab.getAttribute('href');
    root.classList.add('is-loading');
    fetchDoc(href).then(function (doc) {
      var nr = doc.querySelector('[data-tlb-looks]'); if (!nr) throw new Error('no feed');
      ['[data-grid]', '.tlb-looks__more', '.tlb-looks__count', '.tlb-looks__tabs'].forEach(function (sel) {
        var a = root.querySelector(sel), b = nr.querySelector(sel);
        if (a && b) a.replaceWith(document.importNode(b, true));
      });
      if (window.TLBVideo) TLBVideo.scan(root);
      root.dataset.sectionId = nr.dataset.sectionId; root.dataset.tag = nr.dataset.tag;
      if (history.pushState) history.pushState({ tlbTab: href }, '', href);
      feedUrl = location.href;
      root.classList.remove('is-loading');
      var on = root.querySelector('.tlb-looks__tab.is-on');
      if (on && window.innerWidth < 750) on.scrollIntoView({ block: 'nearest', inline: 'center' });
      toGridTop();
    }).catch(function () { location.href = href; });
  });

  /* More looks */
  root.addEventListener('click', function (ev) {
    var more = ev.target.closest && ev.target.closest('[data-more]');
    if (!more || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
    ev.preventDefault();
    if (more.getAttribute('aria-busy') === 'true') return;
    more.setAttribute('aria-busy', 'true');
    var href = more.getAttribute('href');
    fetchDoc(withParam(href, 'section_id', root.dataset.sectionId)).then(function (doc) {
      var g = doc.querySelector('[data-grid]'), grid = root.querySelector('[data-grid]');
      if (g && grid) Array.prototype.slice.call(g.children).forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      var nm = doc.querySelector('[data-more]');
      if (nm) { more.setAttribute('href', nm.getAttribute('href')); more.removeAttribute('aria-busy'); } else { more.remove(); }
      var prev = root.querySelector('[data-prev]'); if (prev) prev.remove();
      if (window.TLBVideo) TLBVideo.scan(grid);
    }).catch(function () { location.href = href; });
  });

  /* Look dialog */
  function lookUrl(rank, view) {
    var u = new URL(location.pathname, location.href);
    if (/[?&]preview_theme_id=/.test(location.search)) u.searchParams.set('preview_theme_id', new URL(location.href).searchParams.get('preview_theme_id'));
    u.searchParams.set('view', view); u.searchParams.set('page', rank);
    return u.toString();
  }
  function show(rank, push) {
    if (!dlg || typeof dlg.showModal !== 'function') { location.href = lookUrl(rank, 'look'); return; }
    openRank = rank;
    body.classList.add('is-loading');
    if (!dlg.open) { dlg.showModal(); document.documentElement.classList.add('tlb-dlg-open'); if (window.TLBVideo) TLBVideo.hold(true); }
    fetch(lookUrl(rank, 'look-frag'), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (openRank !== rank) return;
        if (window.TLBVideo) TLBVideo.release(body);
        body.innerHTML = html; body.classList.remove('is-loading');
        if (window.TLBVideo) TLBVideo.scan(body);
        var fr = dlg.querySelector('.tlb-look-dlg__frame'); if (fr) fr.scrollTop = 0;
        var t = body.querySelector('.tlb-look__title'); if (t) dlg.setAttribute('aria-label', t.textContent.trim());
      }).catch(function () { location.href = lookUrl(rank, 'look'); });
    if (push && history.pushState) history.pushState({ tlbLook: rank }, '', lookUrl(rank, 'look'));
  }
  function close(fromPop) {
    if (!dlg || !dlg.open) return;
    dlg.close(); openRank = null; document.documentElement.classList.remove('tlb-dlg-open');
    if (window.TLBVideo) { TLBVideo.release(body); TLBVideo.hold(false); }
    if (!fromPop && history.state && history.state.tlbLook) history.back();
  }
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-look]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
    ev.preventDefault();
    var inDlg = dlg && dlg.contains(a);
    if (inDlg && history.replaceState) { show(a.getAttribute('data-look'), false); history.replaceState({ tlbLook: a.getAttribute('data-look') }, '', lookUrl(a.getAttribute('data-look'), 'look')); }
    else show(a.getAttribute('data-look'), true);
  });
  if (dlg) {
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg || (ev.target.closest && ev.target.closest('[data-close]'))) close(false); });
    dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); close(false); });
  }
  window.addEventListener('popstate', function (ev) {
    var st = ev.state || {};
    if (st.tlbLook) { show(st.tlbLook, false); return; }
    if (dlg && dlg.open) close(true);
    if (location.href !== feedUrl && !st.tlbLook) { feedUrl = location.href; location.reload(); }
  });
})();
